import { createSlice } from '@reduxjs/toolkit'
import {
  partnerDataFulfilled,
  partnerDataPending,
  partnerDataRejected,
} from 'legacy/lut/features/partner360/configuration'
import { map621ToMarketSector } from 'legacy/lut/services/partner360/marketInfo/mappings/map621ToMarketSector'
import { map621ToVerticalMarket } from 'legacy/lut/services/partner360/marketInfo/mappings/map621ToVerticalMarket'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { requestChangePartnerMarketLeasing } from './api/requestChangePartnerMarketLeasing'
import { requestPartnerMarketLeasing } from './api/requestPartnerMarketLeasing'
import { requestUpdatePartnerMarketInfo } from './api/requestUpdatePartnerMarketInfo'
import { requestUpdateVerticalMarketInfo } from './api/requestUpdateVerticalMarketInfo'
import { initialState } from './configs'
import { PARTNER360_MARKET_INFO_NAMESPACE } from './constants'

const marketInfoSlice = createSlice({
  name: PARTNER360_MARKET_INFO_NAMESPACE,
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(partnerDataPending, (state) => {
        state.status = RequestStatus.PENDING
        state.message = 'fetching data...'
      })
      .addCase(partnerDataRejected, (state, action) => {
        state.status = RequestStatus.REJECTED
        if (action.payload) {
          state.message = action.payload
        }
      })
      .addCase(partnerDataFulfilled, (state, action) => {
        state.status = RequestStatus.FULFILLED
        state.message = 'Success'

        state.data.marketSector = map621ToMarketSector(action.payload)
        state.data.verticalMarket = map621ToVerticalMarket(action.payload)
      })

      .addCase(requestUpdatePartnerMarketInfo.pending, (state) => {
        state.status = RequestStatus.PENDING
        state.message = 'Updating marketSector data'
      })
      .addCase(requestUpdatePartnerMarketInfo.rejected, (state, action) => {
        state.status = RequestStatus.REJECTED
        if (action.error.message) {
          state.message = action.error.message
        }
      })
      .addCase(requestUpdatePartnerMarketInfo.fulfilled, (state, action) => {
        state.status = RequestStatus.FULFILLED
        state.message = 'MarketSector is updated'

        state.data.marketSector = action.payload
      })

      .addCase(requestUpdateVerticalMarketInfo.pending, (state) => {
        state.status = RequestStatus.PENDING
        state.message = 'Updating verticalMarket data'
      })
      .addCase(requestUpdateVerticalMarketInfo.rejected, (state, action) => {
        state.status = RequestStatus.REJECTED
        if (action.error.message) {
          state.message = action.error.message
        }
      })
      .addCase(requestUpdateVerticalMarketInfo.fulfilled, (state, action) => {
        state.status = RequestStatus.FULFILLED
        state.message = 'VerticalMarket is updated'

        state.data.verticalMarket = action.payload
      })

      .addCase(requestPartnerMarketLeasing.pending, (state) => {
        state.status = RequestStatus.PENDING
        state.message = 'Fetching marketLeasing data...'
      })
      .addCase(requestPartnerMarketLeasing.rejected, (state, action) => {
        state.status = RequestStatus.REJECTED
        if (action.error.message) {
          state.message = action.error.message
        }
      })
      .addCase(requestPartnerMarketLeasing.fulfilled, (state, action) => {
        state.status = RequestStatus.FULFILLED
        state.message = 'MarketLeasing is loaded'

        state.data.marketLeasing = action.payload
      })

      .addCase(requestChangePartnerMarketLeasing.pending, (state) => {
        state.status = RequestStatus.PENDING
        state.message = 'Changing MarketLeasing...'
      })
      .addCase(requestChangePartnerMarketLeasing.rejected, (state, action) => {
        state.status = RequestStatus.REJECTED
        if (action.error.message) {
          state.message = action.error.message
        }
      })
      .addCase(requestChangePartnerMarketLeasing.fulfilled, (state, action) => {
        state.status = RequestStatus.FULFILLED
        state.message = 'MarketLeasing is updated'

        state.data.marketLeasing = action.payload
      }),
})

export default marketInfoSlice.reducer
